import keys from '~/pages/setting/TTN_create.json'
import driverKey from '~/pages/driver/setting/driver.json'
import vehicleKey from '~/pages/vehicle/setting/vehicle.json'
import { debounceTime, distinctUntilChanged, filter, pluck, switchMap } from 'rxjs/operators'
//services
import { coreApi } from '~/services/core'
import { contractsService } from '~/services/ContractsService'
import { empowermentService } from '~/services/EmpowermentService'
import { orderService } from '~/services/OrderService'
import { driverService } from '~/services/DriverSerivce'
import { vehicleService } from '~/services/VehicleService'
import { terminalService } from '~/services/TerminalService'

export const checkProduct = (products, product) => {
  if (!products || !product) return

  if (products?.length === 0) {
    alert('В базе нет товаров')
    return
  }

  const hasProduct = products.find(({ Id }) => Id === product.ProductId)

  if (!hasProduct) {
    alert('Выьранной базе отсутствует етот товар')
  }
}


export default {
  data() {
    return {
      searchBuyer: null,
      searchContract: null,
      loading: false,
      radio1: false,
      radio2: true,
      formTitle: 'СОЗДАТЬ ТТН',
      waybill: {
        TerminalShow: true,
        ShowShipmentDate: true,
        ShipmentDescription: '',
        NoTransport: false
      },
      keys: keys,
      //arrays
      buyers: [],
      orders: [],
      contracts: [],
      appendixes: [],
      epowerments: [],
      startDateKeys: {
        attrs: {
          readonly: false,
          outlined: true,
          dense: true,
          label: 'Дата ТТН'
        }
      },
      driver: {
        Id: null,
        Name: '',
        Temporary: true
      },
      vehicle: {
        Id: null,
        Name: '',
        Model: '',
        Volume: '',
        Temporary: true
      },
      driverKey: driverKey,
      vehicleKey: vehicleKey,
      terminals: []
    }
  },
  components: {
    OilForm: () => import('~/components/helper/oil.form'),
    OilProduct: () => import('./oilProduct_test'),
    OilModal: () => import('~/components/helper/form/oil.delete.modal'),
    DatePicker: () => import('~/components/helper/form/oil.date.picker')
  },
  subscriptions() {
    return {
      contracts$: this.searchContract$.pipe(
        pluck('event', 'target', 'value'),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(query => coreApi.get(`contract/search/number?pattern=${query}`)),
        pluck('data')
      ),
      buyers$: this.searchCompany$.pipe(
        pluck('event', 'target', 'value'),
        debounceTime(200),
        filter(value => value.length > 2),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(query => coreApi.get(`company/search/name?pattern=${query}`)),
        pluck('data')
      ),
      vehicles$: this.searchVehicle$.pipe(
        pluck('event', 'target', 'value'),
        debounceTime(50),
        filter(value => value.length > 2),
        debounceTime(50),
        distinctUntilChanged(),
        switchMap(query => coreApi.get(`vehicle/search/liter?pattern=${query}`)),
        pluck('data')
      ),
      drivers$: this.searchDriver$.pipe(
        pluck('event', 'target', 'value'),
        debounceTime(200),
        filter(value => value.length > 2),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(query => coreApi.get(`driver/search/name?pattern=${query}`)),
        pluck('data')
      )
    }
  },
  domStreams: ['searchCompany$', 'searchContract$', 'searchVehicle$', 'searchDriver$'],

  async created() {
    const terminals = await terminalService.getAll()

    this.terminals = terminals.data
  },

  methods: {
    reset() {
      this.buyers = []
      this.orders = []
      this.contracts = []
      this.appendixes = []
      this.epowerments = []
    },

    async saveDriver(driver, dialog) {
      driver.Temporary = true
      const response = await coreApi.get('generate/id')
      const id = response.data
      if (!id) {
        return
      }
      driver.Id = id
      this.driver = driver
      this.waybill.Driver = driver
      this.drivers$ ??= []
      this.drivers$.push({ ...driver })
      dialog.value = false
    },
    async saveVehicle(vehicle, dialog) {
      vehicle.Temporary = true
      delete vehicle.Trailer1
      delete vehicle.Trailer2

      vehicle.Number = vehicle.ModelRegistrationNumber

      const response = await coreApi.get('generate/id')
      const id = response.data
      if (!id) {
        return
      }
      vehicle.Id = id
      this.waybill.Vehicle = vehicle
      this.vehicles$ ??= []
      this.vehicles$.push({ ...vehicle })
      dialog.value = false
    },
    async changeBuyer(buyer) {
      if (!buyer) return
      const id = buyer.Id
      this.waybill.Buyer = { ...buyer }
      this.waybill.Receiver = { ...buyer }
      const contracts = await contractsService.contractCompanyById({ companyId: id })
      this.contracts = contracts.data || []
      const empowers = await empowermentService.getCompanyById({ companyId: buyer.Id })
      this.epowerments = empowers.data || []
    },

    async changeVehicle(vehicle) {
      if (!vehicle) return
      if (vehicle?.Temporary) return
      this.waybill.Vehicle = vehicle
      this.waybill.Vehicle.Number = vehicle.ModelRegistrationNumber
      const vehicles = await driverService.fromVehicleId(vehicle.Id)
      this.drivers$ = []
      this.drivers$ = vehicles.data || []
    },


    async changeDriver(driver) {
      if (!driver) return
      if (driver?.Temporary) return
      this.waybill.Vehicle = {}
      this.waybill.Driver = { ...driver }
      const response = await vehicleService.getById({ id: driver.VehicleId, isOwn: true })
      const vehicle = response.data
      this.waybill.Vehicle = vehicle
      this.waybill.Vehicle.Number = vehicle.ModelRegistrationNumber
      this.vehicles$ ??= []
      this.vehicles$.push(vehicle)
    },
    async changeContract(contract) {
      if (!contract) return
      this.waybill.Contract = { ...contract }
      this.waybill.Buyer = { ...contract.Buyer }
      if (this.waybill?.Buyer) {
        const empowers = await empowermentService.getCompanyById({ companyId: this.waybill.Buyer.Id })
        this.epowerments = empowers.data || []
      }

      this.appendixes = contract.Appendixes || []
      this.waybill.Status = contract.Status
      const orders = await orderService.getContractsById(contract.Id)
      this.orders = orders.data
    },

    async changeAppendix(appendix) {
      if (!appendix) return
      this.waybill.Appendix = { ...appendix }

      this.waybill.Item = { ...appendix?.Item, tmpExcise: 0 }

      const buyer = this.waybill.Contract.Buyer

      const HasPrivelege = buyer.HasPrivelege
      this.waybill.Item.AmountInTonne = ''
      this.waybill.Item.AmountInLitre = ''
      this.waybill.Item.GrossPricePerLitre = ''
      this.waybill.Item.tmpExcise = HasPrivelege === true ? 0 : this.waybill.Item.Excise
      checkProduct(this.waybill?.Terminal?.Products, this.waybill.Item)
    },
    changeTerminal(terminal) {
      if (!terminal) return

      const appendix = this.waybill.Appendix
      const item = appendix?.Item
      const products = terminal?.Products
      const hasProduct = products.find(({ Id }) => Id === item?.ProductId)
      this.waybill.Terminal = { ...terminal }
      // checkProduct(products, item)
    },
    async changeEmpowerment(empowerment) {
      if (!empowerment) return
      this.waybill.Empowerment = { ...empowerment }
    },
    async changeOrder(order) {
      if (!order) return
      this.waybill.Order = { ...order }
    },
    async changeVehicleTrailer1(Trailer1) {
      if (!Trailer1) return
      this.waybill.Trailer1 = Trailer1
    },
    async changeVehicleTrailer2(Trailer2) {
      if (!Trailer2) return
      this.waybill.Trailer2 = Trailer2
    },

    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    }
  },
  watch: {
    'waybill.NoTransport'(t) {
        console.log(t)
    },
    buyers(buyers) {
      this.keys['Buyer.Id'].attrs.items = buyers || []
      this.keys['Receiver.Id'].attrs.items = buyers || []
      this.buyers$ = buyers || []
    },
    orders(orders) {
      this.keys['Order.Id'].attrs.items = orders || []
    }
    ,
    contracts(contracts) {
      this.keys['Contract.Id'].attrs.items = contracts || []
      this.contracts$ = contracts || []
    }
    ,
    appendixes(appendixes) {
      this.keys['Appendix.Id'].attrs.items = appendixes || []
    }
    ,
    epowerments(epowerments) {
      this.keys['Empowerment.Id'].attrs.items = epowerments || []
    }

  }
}